type Duration = { hours: number; minutes: number };

export function minutesToDuration(totalMinutes: number): Duration {
  return {
    hours: Math.floor(Math.abs(totalMinutes) / 60),
    minutes: Math.abs(totalMinutes) % 60,
  };
}

export function durationToMinutes(duration: Duration): number {
  return duration.hours * 60 + duration.minutes;
}

export function parseTimeString(timeString: string): Duration {
  if (!timeString) {
    return { hours: 0, minutes: 0 };
  }

  const [hours, minutes] = timeString.split(":").map(Number);

  if (isNaN(hours) || isNaN(minutes)) {
    return { hours: 0, minutes: 0 };
  }

  return { hours: Number(hours), minutes: Number(minutes) };
}

export function formatDurationToTimeString(duration: Duration): string {
  return `${String(duration.hours).padStart(2, "0")}:${String(duration.minutes).padStart(2, "0")}`;
}

export function calculateShiftDuration(
  start: Date | string | number,
  end: Date | string | number,
  breakMinutes: number = 0,
): Duration {
  const startDate = new Date(start);
  const endDate = new Date(end);

  const diffMinutes = Math.floor((endDate.getTime() - startDate.getTime()) / (1000 * 60));
  return minutesToDuration(diffMinutes - breakMinutes);
}

export function formatDurationToISO(duration: Duration): string {
  return `PT${duration.hours}H${duration.minutes}M`;
}

export function getUtcStartOfDay(): string {
  return new Date(
    Date.UTC(new Date().getUTCFullYear(), new Date().getUTCMonth(), new Date().getUTCDate()),
  ).toISOString();
}
